module.exports = __webpack_public_path__ + "static/img/nullbg.9bd6ab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nullbg.png
// module id = rngD
// module chunks = 1